
export type MilestoneType = "air" | "ocean";
export type GROUND_STAFF = {
  _id: string;
  name: string;
  username: string;
}


export interface SelectOption {
  label: string;
  value: string;
}


export interface MultiSelectProps {
  options: SelectOption[];
  value: SelectOption[];
  onChange: (value: SelectOption[]) => void;
  placeholder?: string;
  isDisabled?: boolean;
}


export type TabType = "first-mile" | "middle-mile" | "last-mile";

export interface MilestoneItem {
  id: string;
  name: string;
  description: string;
  type?: string;
  isFromApi?: boolean;
  isNew?: boolean;
  customMilestone?: string;
  milestone?: string;
  _id?: string;
  groundStaffIds?: string[]; 
  groundStaffOptions?: SelectOption[]; 
}

 export const typeMap: Record<TabType, string | null> = {
  "first-mile": "first",
  "middle-mile": null,
  "last-mile": "last",
};
export interface MilestoneContentProps {
  activeTab: TabType;
  milestones: MilestoneItem[];
  handleTabChange: (newTab: TabType) => void;
  addMilestone: () => void;
  removeMilestone: (id: string) => void;
  handleMilestoneChange: (
    id: string,
    field: keyof Omit<MilestoneItem, "id">,
    value: string, 
    tab?: TabType
  ) => void;
  parentType: "air" | "ocean";
}

